module.exports = __webpack_public_path__ + "img/street-fighter.930df1bf.png";